/*
 * This file is part of glowingblue/orell-articles.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Modal, { IInternalModalAttrs } from 'flarum/common/components/Modal';
import type Article from '../models/Article';
import type Mithril from 'mithril';

export interface ArticleNoteModalAttrs extends IInternalModalAttrs {
	article: Article;
}

export default class ArticleNoteModal extends Modal<ArticleNoteModalAttrs> {
	article!: Article;

	oninit(vnode: Mithril.Vnode<ArticleNoteModalAttrs, this>) {
		super.oninit(vnode);
		this.article = this.attrs.article;
	}

	className(): string {
		return 'ArticleBookshelfDropdownModal ArticleNoteModal Modal--medium';
	}

	title(): Mithril.Children {
		return app.translator.trans('glowingblue-orell-bookshelf.forum.article_dropdown.see_note');
	}

	content() {
		return <div className="Modal-body">{this.dropdownView()}</div>;
	}

	dropdownView() {
		return null;
	}
}
